import { render, staticRenderFns } from "./Chicken.vue?vue&type=template&id=c82a5d6e&scoped=true&"
import script from "./Chicken.vue?vue&type=script&lang=js&"
export * from "./Chicken.vue?vue&type=script&lang=js&"
import style0 from "./Chicken.vue?vue&type=style&index=0&id=c82a5d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82a5d6e",
  null
  
)

export default component.exports